import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { AuthLayout, FormError } from "../components/AuthLayout";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/scan");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Log in" subtitle="Back for another cast.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div>
          <label className="brut-label">Email</label>
          <input className="brut-input" type="email" required autoComplete="email" value={email}
            onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
        </div>
        <div>
          <label className="brut-label">Password</label>
          <input className="brut-input" type="password" required autoComplete="current-password" value={password}
            onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
        </div>
        <FormError msg={error} testId="login-error" />
        <button className="brut-btn w-full" disabled={busy} data-testid="login-submit-btn">{busy ? "Logging in…" : "Log in"}</button>
      </form>
      <div className="mt-6 flex justify-between text-sm">
        <Link to="/forgot" className="text-zinc-400 hover:text-white underline" data-testid="login-forgot-link">Forgot password?</Link>
        <Link to="/signup" className="text-[#FF4D00] font-bold" data-testid="login-signup-link">Create account</Link>
      </div>
    </AuthLayout>
  );
}
